// extracted by mini-css-extract-plugin
export default {"surecoGrid":"mRR1983iElZHRkjTiMTH"};